import { cn } from '@/lib/utils';
import { formatCurrency } from '@/utils/currency';
import { calcAmountWithDiscount, getFormattedDiscountCouponValue } from '@/utils/discount-coupons';
import { Order } from '@/utils/types';
import Link from 'next/link';
import { Button } from '../ui/button';

export default function NextCartStepButton(props: {
  cart: Order[];
  cartSubtotalNoFee: number;
  cartSubtotalFee: number;
  discountCoupon: any;
  lng: string;
  text: string;
  donation: number;
  className?: string;
  disabled?: boolean;
}) {
  const {
    cart,
    cartSubtotalNoFee,
    cartSubtotalFee,
    discountCoupon,
    lng,
    text,
    donation,
    className,
    disabled = false,
  } = props;

  return (
    <>
      <div className={cn(className)}>
        <Link href={disabled ? '#' : `/cart`} aria-disabled={disabled}>
          <Button
            disabled={disabled}
            className='flex h-[68px] w-full items-center justify-between text-lg font-light max-sm:h-[60px]'>
            {text}
            <span>
              <span>
                {formatCurrency(
                  calcAmountWithDiscount({ cartSubtotalNoFee, cartSubtotalFee, cart }, discountCoupon) + donation,
                  lng as string
                )}
              </span>
              &nbsp;
              {discountCoupon && (
                <span className='text-zinc-300'>
                  (Cupom aplicado:&nbsp;
                  {getFormattedDiscountCouponValue(discountCoupon, {
                    cart,
                    cartSubtotalFee,
                    cartSubtotalNoFee,
                  })}
                  )
                </span>
              )}
            </span>
          </Button>
        </Link>
      </div>
    </>
  );
}
